import actions from './store/actions';
import createRouterMiddleware from '@synergycms_core/middlewares/actionRouter';
import initializeStore, { getParamsFromWindow } from './start';
import { fromJS, Map, List } from 'immutable';
import {
  recoverReservation,
  recoverBookingBlocksFromAvailMail,
  generateBlockFromParams
} from './store/customer/reservation/reservationUtils';
import { pipe } from 'ramda';
import storage from '@synergycms_core/utils/storage';
import moment from 'moment';
import { getCompanyAvailIdentifier } from './store/customer/corporateActions';

const {
  currencies: currenciesActions,
  currencyCountry: currencyCountryActions,
  currentCurrency: currentCurrencyActions,
  step: stepActions,
  ipCountry: ipCountryActions,
  params: paramActions,
  currentHotels: currentHotelsActions,
  currentHotel: currentHotelAction,
  filters: filtersActions,
  orderBy: orderByActions,
  roomPreferences: roomPreferencesActions,
  cardMask: cardMaskActions,
  hasCvv: hasCvvActions,
  reservation: reservationActions,
  loyalty:loyaltyActions,
  corporate: corporateActions,
} = actions.customer;


const hotelsActions = actions.hotels;
const availActions = actions.avail;
const availServicesActions = actions.availServices;
const availCacheActions = actions.availCache;


export const RouteResolver = (arrayHash, queryObj) => {
  return (dispatch, getState) => {
    let [baseRoute, currency = false, reservationTrackingId = queryObj.get('tracking_id') || false] = arrayHash;
    let availInitializePromise = Promise.resolve();

    queryObj = pipe(
      fromJS,
      getParamsFromWindow
    )(queryObj);
    if (validParams(queryObj)) {
      // CANVI URL
      if (!getState().getIn(['customer', 'step', 'loaded'])) {
        //inicialització del store
        const initializeValues = initializeStore(baseRoute, arrayHash, queryObj, dispatch);
        // inicialització del stepmanager
        dispatch(stepActions.initialize(initializeValues));
      } else {
        dispatch(stepActions.change(baseRoute || getState().getIn(['customer', 'step', 'list', 0, 'code'])));
      }

      let currentStep = getCurrentStep(getState);


      const loginConfig = window.frontLoader?.['cms-login']?.config || false;
      let loggedUserPromise = Promise.resolve();

      if(loginConfig){

        const { entity } = loginConfig;
        
        let loginContext = {
          key: '',
          value: ''
        };

        if(loginConfig.hotel_id){
          loginContext.key = 'hotel_id';
          loginContext.value = loginConfig.hotel_id;
        } else if(loginConfig.group_id){
          loginContext.key = 'group';
          loginContext.value = getState().get('group', '');
        }
        
        if(window.LoginUser?.company_id){
          dispatch(corporateActions.get(window.LoginUser));
        } else {

          let remember = 0;
          const loginUserInfo = storage.get("login_user") || (remember = 1, storage.getLocal("login_user")) || null;

          if(loginUserInfo){
            const {user_id = '', token = ''} = loginUserInfo;
            const authToken = btoa(`${user_id}:${token}`);
            if(entity === 'company'){
              loggedUserPromise = dispatch(corporateActions.getUserAsync(loginContext, authToken, remember, loginUserInfo));
            } else if(entity === 'loyalty'){
              loggedUserPromise = dispatch(loyaltyActions.getUserAsync(loginContext, authToken, remember, loginUserInfo));
            }
          }
        }

      }

      //validem q el tipo de parametre d'hotel estigui correcte respecte l'step, en cas contrari redirigim la ruta
      if (queryObj.get('hotelCodes') && currentStep.get('type') !== 'multi') {
        dispatch(stepActions.change('multiHotelAvail'));
      }
      if (queryObj.get('hotelCode') && currentStep.get('type') !== 'mono') {
        dispatch(stepActions.change('monoHotelAvail'));
      }

      currentStep = getCurrentStep(getState);

      let  windowConfig = {}
      if(window.frontLoader && window.frontLoader['cms-avail']){
        windowConfig = {
          ...window.frontLoader.hotel_id && {hotel_id:window.frontLoader.hotel_id},
          ...(window.frontLoader.hotels_info && { hotels_info: window.frontLoader.hotels_info }),
        }
      }else if(window.engine_sygy_data){
        windowConfig  = window.engine_sygy_data
      }
      
      const hotId = windowConfig.hotel_id || window.id_hotel
      const hotelsInfo = windowConfig.hotels_info || window.hotels_info 
      let appPromise = Promise.resolve();
      if (!hotelsInfo && hotId) {
        appPromise = dispatch(actions.app.config.getHotelAsync("cms-avail;cms-engine", hotId))
      }else{
        appPromise = dispatch(actions.app.config.getAsync("cms-avail;cms-engine"))
      }
      
      const paramsPromises = [
        dispatch(currenciesActions.getAsync()),
        appPromise,
        loggedUserPromise
      ];

      const paramsPromise = Promise.all(paramsPromises).then(() => {
        
        const corporateObject = getCompanyAvailIdentifier(getState().getIn(['customer', 'corporate'], Map()));
        
        if(corporateObject){
            queryObj = queryObj.set('company_id', corporateObject.value);
        } else {
          queryObj = queryObj.set('company_id', null);
        }

        dispatch(currentCurrencyActions.set(currency));
        return dispatch(currencyCountryActions.getAsync()).then(() => {
        dispatch(paramActions.createFromUrl(queryObj, currentStep));
        //validem q els hotels existeixin
        const urlParams = getState().getIn(['customer', 'params', 'params']);
        if (!urlParams.get('hotels').size && !urlParams.get('hotelId')) {
          dispatch(actions.router.error());
        }
        })
      });

      if(queryObj.get('POS', null) !== null) {
        storage.setLocal('POS', queryObj.get('POS'));
      }
      
      switch (currentStep.get('code')) {
        case 'multiHotelAvail':
          availInitializePromise = paramsPromise.then(() => {
            dispatch(currentHotelAction.clear());
            dispatch(currentHotelsActions.set());
            return Promise.all([
              dispatch(hotelsActions.getAsync()),              
              dispatch(loyaltyActions.getDescriptiveAsync(getState().get('group'))).then(()=>dispatch(availActions.getAvailAsync(getState().get('group'),'loyalty')))
            ]).then(() => {
              // Init orderBy and filters
              dispatch(currentCurrencyActions.set(currency));
              dispatch(orderByActions.set(getState().get('group', false) === 'eurostarshotels' ? 'proximity' : 'price'));
              dispatch(filtersActions.get());
              return Promise.all([
                dispatch(availServicesActions.getAsync())
              ]);
            });
          });
          break;
        case 'cancelation':
        case 'newCof':
          return paramsPromise.then(() => {
            const pin = getState().getIn(['customer', 'params', 'params', 'pin'], false);

            if (reservationTrackingId && pin) {
              dispatch(currentHotelAction.set());
              let reservationPromise = queryObj.get('from_tms') === 'true' ?
                dispatch(reservationActions.getTmsAsync(reservationTrackingId, pin)) :
                dispatch(reservationActions.getAsync(reservationTrackingId, pin));

              return Promise.props({
                reservation: reservationPromise,
                hotel: dispatch(hotelsActions.getAsync())
              }).then((props) => {
                if (currentStep.get('code') === 'newCof') {
                  const reservation = props.reservation;
                  return Promise.props({
                    cardMask: dispatch(cardMaskActions.getAsync(reservation)),
                    hasCvv: dispatch(hasCvvActions.getAsync(reservation))
                  }).finally(() => {
                    dispatch(actions.router.update(true));
                    return true;
                  });
                } else {
                  dispatch(actions.router.update(true));
                  return true;
                }
              });
            } else {
              dispatch(actions.router.update(true));
            }
          });
        case 'monoHotelAvail':
        case 'serviceHotelAvail':
        case 'customerForm':
        case 'confirmation':
        default:
          availInitializePromise = paramsPromise.then(() => {
            dispatch(currentHotelAction.set());

            const promises = [
              dispatch(hotelsActions.getAsync()),
              dispatch(availServicesActions.getAsync()),
              dispatch(loyaltyActions.loyaltyAsync()).then(()=> dispatch(availActions.getAvailAsync(false,'loyalty')))
            ];

            const stepType = getStepType(getState);

            if(currentStep.get('code') === 'monoHotelAvail' && stepType !== 'WI') {
              let availCacheParams = getState().getIn(['customer', 'params', 'avail_cache_params'],Map());
              const availCacheStringParams = getState().getIn(['customer', 'params', 'avail_cache_query_params']);
              const cities = getState().getIn(['hotels', 'hotels_info', 'cities'], List());
              const hotelsDescriptives = getState().getIn(['hotels']);
              const hotelId = getState().getIn(['customer', 'current_hotel']);
              const hotel = hotelsDescriptives.getIn(['hotels_info', 'hotels']).find(hotel => hotel.get('id') === hotelId);
              const hotelCity = cities.find(city => city.get('id') === hotel.get('city_id'));
              const urlParams = getState().getIn(['customer', 'params', 'url_params']);
              
              availCacheParams = availCacheParams.set('city_id', hotelCity.get('id'));
              availCacheParams = availCacheParams.set('hotelId', null);

              promises.push(
                dispatch(availCacheActions.getAsync(
                  moment(urlParams.get('start')), 
                  moment(urlParams.get('end')), 
                  {
                    params: availCacheParams, 
                    stringParams: availCacheStringParams
                  }
                ))
              );
            }

            return Promise.all(promises).then(() => {
              return Promise.all([
                dispatch(ipCountryActions.getAsync()),
                dispatch(availActions.getFlexibleAsync()),
                dispatch(availActions.getLoyaltyFlexibleAsync()),
              ]).then(() => {
                dispatch(currentCurrencyActions.set(currency));
                dispatch(availActions.getAvailParsed());
                dispatch(availActions.setRelatedAvail());
                dispatch(roomPreferencesActions.initialize());
                return true;
              });
            });
          });
      }
      return availInitializePromise.then(() => {
        let recoveredReservationRequest = null;
        if (queryObj.get('selection_avail') && List.isList(queryObj.get('selection_avail'))) {
          const blocks = generateBlockFromParams(getState());
          if (blocks && blocks.size && blocks.some(b => b.get('price', false))) {
            dispatch(actions.customer.reservationRequest.initialize(blocks));
            recoveredReservationRequest = getState().getIn(['customer', 'reservation_request']);
          }
        } else if (queryObj.get('resRequest')) {
          recoveredReservationRequest = recoverBookingBlocksFromAvailMail(getState, queryObj);
        }

        return recoverReservation(dispatch, getState, reservationTrackingId, recoveredReservationRequest).then(
          recoveredTrackingId => {
            const currentStepCode = getCurrentStep(getState).get('code');

            if (
              !recoveredTrackingId &&
              (currentStepCode === 'customerForm' || currentStep.get('code') === 'confirmation')
            ) {
              dispatch(stepActions.change('monoHotelAvail'));
            } else if (
              recoveredTrackingId &&
              currentStep.get('code') === 'confirmation' &&
              getState().getIn(['customer', 'reservation', 'status']) !== 'confirmed'
            ) {
              dispatch(stepActions.change('customerForm'));
            }
            dispatch(actions.router.update(true));

            
            return true;
          }
        );
      });
    } else {
      dispatch(actions.router.error());
    }
  };
};

const getCurrentStep = getState => getState().getIn(['customer', 'step', 'current_step']);
const getStepType = getState => getState().getIn(['customer', 'web_type'], 'WI');

const validParams = queryObj => {
  let validParams = true;
  //Validem parametres necessaris
  if (!queryObj.get('hotelCodes') && !queryObj.get('hotelCode')) {
    validParams = false;
  }

  return validParams;
};

export default createRouterMiddleware(RouteResolver, { fireInitial: true });
